import { Common } from '~/models/common';
import { Socials } from '~/models/socials';

export const socialsService = {
	fetch: async (): Promise<Socials.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
		};

		// const { getSingletonItem } = useDirectusItems();

		try {
			// const response = await getSingletonItem<Socials.Model[]>({
			// 	collection: Socials.collection,
			// 	params,
			// });
			const response = await $fetch<Socials.Model[]>(Socials.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Socials:', error);

			return [];
		}
	},
};
